<template>
  <div>
    <div class="phone-area">
      <div class="phone-area-title"><span>联系电话</span></div>
      <div class="phone-area-text">
        <z-field
          v-model="contact"
          type="number"
          placeholder="请填写电话，以便联系您解决问题"
          maxlength="20"
          clearable
          @blur="txtPhoneBlur"
          @focus="textPhoneFocus"
          ref="textPhoneInput"
          class="text-phone"
        />
      </div>
    </div>
    <div class="more-info-area" :class="{ 'moreLeng': focusTextArea }">
      <more-info-section label="上传开箱视频/细节图">
        <div class="more-info-area-submit-form-area">
          <div class="more-info-area-submit-form-upload">
            <z-upload
              v-model="zzfiles"
              ref="uploadRef"
              :process-file="processFile"
              accept="image/*, video/*"
              btn-img-video
              :is-show-process="true"
              :max="max"
              :chooseMediaPhotosParameter="chooseMediaPhotosParameter"
            >
              <div class="custom-upload">
                <z-upload-file
                  v-for="(file, index) in zzfiles"
                  :file="file"
                  :key="index"
                  @click="handlePreview"
                />
                <z-upload-btn v-if="showBtn">
                  <i>＋</i>
                  <span>上传</span>
                </z-upload-btn>
              </div>
            </z-upload>
          </div>
        </div>
      </more-info-section>
    </div>
    <div class="more-info-area">
      <more-info-section label="其他问题">
        <div class="more-info-area-submit-form-area">
          <div class="more-info-area-submit-form-textarea">
          <textarea
            ref="textInput"
            type="text"
            v-model="msgTxt"
            placeholder="如果还有其他问题，请详细描述"
            rows="1"
            @blur="txtBoxBlur"
            @focus="textBoxFocus"
            @input="updateTextInfo"
          ></textarea>
          <!-- <div class="more-info-area-submit-form-textarea-num-wrap">
            <p class="more-info-area-submit-form-textarea-num">
              <span :class="{ red: msgTxt.length >= maxNum }">{{ msgTxt.length }}</span
              >/{{ maxNum }}
            </p>
          </div> -->
          </div>
        </div>
      </more-info-section>
    </div>
    <!-- <z-button-group>
      <z-button @click="confirmSubmit" :disabled="!canSubmit" type="primary">提交</z-button>
    </z-button-group> -->
  </div>
</template>

<script>

import { Field, Upload, Toast, ImagePreview } from '@zz-common/zz-ui'
import MoreInfoSection from '../../more-info-section'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { getCookie, isZlj, isAndroid } from '../../../../../lib/utils'
import { addUserComplain } from '../../../../../api/resourceApi'

const MAX_INPUT_NUM = 100

export default {
  name: 'C2COhterSpecialOrderForm',
  components: {
    'z-field': Field,
    'z-upload': Upload,
    zUploadBtn: Upload.Btn,
    zUploadFile: Upload.File,
    MoreInfoSection
  },
  props: {
    // 订单ID
    orderId: {
      type: String,
      default: ''
    },
    // 是否为订单
    isOrder: {
      type: Number,
      default: 0
    },
    // 选择的问题类型
    questionTypeId: {
      type: String,
      default: ''
    },
    // 订单所属业务线
    businessType: {
      type: String,
      default: ''
    },
    orderItem: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    questionTypeId(curval, _newVal) {
      console.log('curVal is ???', curval)
      this.testOrderId = curval
    },
    orderItem(curval, _newVal) {
      console.log('curVal  orderitemis ???', curval)
      // this.testOrderId = curval
    }
  },
  computed: {
    Currcomp() {
      return this.ComputedComp()
    },
    showBtn() {
      return this.max > this.zzfiles.length;
    },
    canSubmit() {
      return this.msgTxt.length
    },
    chooseMediaPhotosParameter() { // zz端内上传参数
      return {
        maxImagesCount: this.max,
        maxVideosCount: this.max,
        videoLength: 100,
        isNeedShowVideo: 1,
        isShowVideoList: 1,
        maxCount: this.max,
        authScene: 'complainUpload',
        authSceneName: '投诉中心上传图片视频',
        authAlertTitle: '系统想访问您的相册',
        authAlertContent: '为了您能正常反馈问题，我们需要您授权相册权限'
      }
    }
  },
  data() {
    return {
      contact: '',
      msgTxt: '',
      maxNum: MAX_INPUT_NUM,
      max: 9,
      zzfiles: [],
      // canSubmit: false,
      testOrderId: '',
      // APP种类
      clientType: isZlj() ? 2 : 1,
      // uid
      uid: getCookie('uid'),
      fetching: false,
      phoneReg: /^1[3456789]\d{9}$/,
      focusTextArea: false
    }
  },
  methods: {
    ComputedComp() {
      return 'i am a normalType Form'
    },
    handlePhoneStartScroll(event) {
      // event.preventDefault() //阻止默认事件（长按的时候出现复制）
      this.startX = event.changedTouches[0].pageX
      this.startY = event.changedTouches[0].pageY
    },
    // 页面滑动，隐藏键盘
    handlePhoneScrollMove(event) {
      event.preventDefault()
      const moveEndX = event.changedTouches[0].pageX
      const moveEndY = event.changedTouches[0].pageY
      const X = moveEndX - this.startX
      const Y = moveEndY - this.startY
      if (Math.abs(Y) > Math.abs(X) && Y > 0) {
        this.$refs.textPhoneInput.blur()
      }
    },
    // 联系电话对应的blur事件
    txtPhoneBlur() {
      window.removeEventListener('touchstart', this.handlePhoneStartScroll)
      window.removeEventListener('touchmove', this.handlePhoneScrollMove)
    },
    // 联系电话对应的focus事件
    textPhoneFocus() {
      window.addEventListener('touchstart', this.handlePhoneStartScroll)
      window.addEventListener('touchmove', this.handlePhoneScrollMove)
    },
    txtBoxBlur() {
      this.focusTextArea = false
      setTimeout(() => {
        window.scrollTo(0, window.pageYOffset)
      }, 100)
      window.removeEventListener('touchstart', this.handleStartScroll)
      window.removeEventListener('touchmove', this.handleScrollMove)
    },
    textBoxFocus() {
      if (isAndroid) {
        this.focusTextArea = true
        this.$nextTick(() => {
          const ele = document.getElementsByClassName('complaint-form')[0]
          if (ele) {
            ele.scrollTop = ele.scrollHeight
          }
        })
      }
      window.addEventListener('touchstart', this.handleStartScroll)
      window.addEventListener('touchmove', this.handleScrollMove)
    },
    handleStartScroll(event) {
      // event.preventDefault() //阻止默认事件（长按的时候出现复制）
      this.startX = event.changedTouches[0].pageX
      this.startY = event.changedTouches[0].pageY
    },
    // 页面滑动，隐藏键盘
    handleScrollMove(event) {
      event.preventDefault()
      const moveEndX = event.changedTouches[0].pageX
      const moveEndY = event.changedTouches[0].pageY
      const X = moveEndX - this.startX
      const Y = moveEndY - this.startY
      if (Math.abs(Y) > Math.abs(X) && Y > 0) {
        this.$refs.textInput.blur()
      }
    },
    updateTextInfo() {
      const elem = this.$refs.textInput
      elem.style.height = 'auto'
      elem.style.height = elem.scrollHeight + 'px'
      elem.scrollTop = elem.scrollHeight
      if (this.msgTxt.length > MAX_INPUT_NUM) {
        this.msgTxt = this.msgTxt.substring(0, MAX_INPUT_NUM)
      }
      this.checkSubmitStatus()
    },
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
        },
        next
      )
    },
    checkSubmitStatus() {
      const submitBtnAbled = this.msgTxt
      // return submitBtnAbled
      this.$emit('checkSubmitStatus', submitBtnAbled)
    },
    checkList() {
      if (!this.zzfiles.length) {
        return true
      } else {
        const findZZFile = this.zzfiles.filter((item) => {
          const { status = '' } = item
          return status !== 'success'
        })
        console.log('findZLJFilefeaf', findZZFile)
        return !findZZFile.length
      }
    },
    confirmSubmit() {
      const uploadingStatus = this.checkList()
      if (!uploadingStatus) {
        Toast('存在上传失败或者上传中的文件,请您检查后重新提交')
        return
      }
      if ((this.contact) && (!this.phoneReg.test(this.contact))) {
        Toast('手机号格式错误')
        return
      }
      if (this.contact.length > 20) {
        Toast('手机号最多输入20位')
        return
      }
      if (this.msgTxt.length < 10) {
        Toast('至少输入10个字描述您的问题')
        return
      }
      if (this.zzfiles.length < 3) {
        Toast('至少上传3张开箱视频或图片')
        return
      }

      let videos = []
      let imgs = []
      if (this.zzfiles.length) {
        this.zzfiles.forEach((item) => {
          const { type = '', url = '' } = item
          // const strIndex = type.lastIndexOf('.')
          //获取后缀
          // const ext = type.substr(strIndex + 1)
          if (type.indexOf('video') > -1) {
            videos.push(url)
          }
          if (type.indexOf('image') > -1) {
            imgs.push(url)
          }
        })
        videos = videos.join('|')
        imgs = imgs.join('|')
      }
      console.log('complain-select-order', this.orderItem)
      const { businessType = '', infoId = '', id = '' } = this.orderItem || {}
      const params = {
        classify: 'complain',
        imgs,
        videos,
        navigator: `${getCookie('model')},${getCookie('v')}`,
        log: '',
        uid: this.uid,
        complainCenter: '1', // 标识客服侧使用的投诉
        contents: `${this.msgTxt}\n手机号：${this.contact}\n订单ID：${this.orderId}`,
        orderId: id,
        faqId: this.questionTypeId,
        businessType,
        infoId
      }
      console.log('params', params)
      console.log('queryParams', params)
      this.submitFormData(params)
    },
    handlePreview() {
      const images = []
      const videoVos = []
      if (this.zzfiles.length) {
        this.zzfiles.forEach((item) => {
          const { type = '', url = '' } = item
          // const strIndex = type.lastIndexOf('.')
          //获取后缀
          // const ext = type.substr(strIndex + 1)
          if (type.indexOf('image') > -1) {
            images.push(url)
            console.log(url)
          }
          if (type.indexOf('video') > -1) {
            videoVos.push({
              // picUrl: 'https://pic3.zhuanstatic.com/zhuanzh/073696c3-ac4c-4554-8aa9-f76f9450a8bd.png',
              auto: false,
              muteBtn: false,
              controls: true,
              videoUrl: url
            })
          }
        })
      }
      console.log('images ', images)
      console.log('videoVos ', videoVos)
      ImagePreview({
        images,
        videoVos,
        startPosition: 0,
        withVideo: true,
        adaptApp: true,
        showLoading: true,
        adaptHeight: true,
        showClose: true
        // onClose({ url, index }) {
        //   console.log(url, index)
        // }
      })
    },
    submitFormData(params) {
      if (this.fetching) {
        Toast('提交中,请稍后重试')
        return
      }
      this.fetching = true
      addUserComplain(params)
        .then((_res) => {
          this.fetching = false
          this.$emit('goToSuccessPage')
        })
        .catch((err) => {
          this.fetching = false
          console.log(err)
        })
    }
  },
  created() {
    console.log('created NormalForm has Changed', this.orderItem)
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
